<div class="price-container">
  <div class="price-copy-container">
    <span class="header">{{ subCategory.subCategoryName | titlecase }} Request</span>
    <div class="copy-container">
      @if (subCategory.customerRequestPrice != null) {
        <span class="copy">Provide the details and images for your request so our design team can create your item!</span>
        <span class="total-container"
          ><span>Total:</span><span>{{ subCategory.customerRequestPrice | currency: "USD" : "symbol" : "1.0-2" }}</span></span
        >
      } @else {
        <span class="copy"
          >We'll review your request and be in touch within {{ itemRequestProcessingDays }} business days with timing and pricing for your
          custom item.<br /><br /><b>You will not be charged until you approve the pricing.</b></span
        >
      }
    </div>
  </div>
  @if (subCategory.customerRequestPrice != null) {
    <span class="price-disclaimer">You will not be charged until our team reviews your request.</span>
  }
</div>
